import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import JsBarcode from "jsbarcode";

const BarcodeDisplay = ({
  value,
  height = 56,
  width,
  displayValue = true,
  fontSize = 14,
}) => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!value || !svgRef.current) return;
    try {
      JsBarcode(svgRef.current, String(value), {
        format: "CODE128",
        height,
        width: width || 1.6,
        displayValue,
        fontSize,
        margin: 8,
        background: "#ffffff",
        lineColor: "#0f172a",
      });
    } catch (error) {
      svgRef.current.innerHTML = "";
    }
  }, [value, height, width, displayValue, fontSize]);

  if (!value) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        bgcolor: "#fff",
        borderRadius: 1,
        px: 1,
        py: 0.5,
      }}
    >
      <svg ref={svgRef} />
    </Box>
  );
};

export default BarcodeDisplay;
